import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const courses = [
  { name: 'AI & Machine Learning', duration: '10 Weeks', level: 'Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'CloudXAI AI Associate', tools: 'Python, TensorFlow, Scikit-learn' },
  { name: 'Azure Data Engineer + GenAI', duration: '3 Months', level: 'Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'DP-203 + CloudXAI', tools: 'Azure, Data Factory, Databricks' },
  { name: 'Cyber Security', duration: '2 Months', level: 'Beginner-Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'CloudXAI Certified', tools: 'Kali Linux, Burp Suite, SIEM' },
  { name: 'AWS DevOps', duration: '3 Months', level: 'Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'AWS + CloudXAI', tools: 'AWS, Docker, Kubernetes, Jenkins' },
  { name: 'Python & SQL Foundation', duration: '2 Months', level: 'Beginner', mode: 'Online / Hybrid', placement: 'Yes', certification: 'CloudXAI Certified', tools: 'Python, SQL, Pandas' },
  { name: 'Snowflake Data Engineering', duration: '2 Months', level: 'Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'Snowflake + CloudXAI', tools: 'Snowflake, dbt, SQL' },
  { name: 'AI Testing & Automation', duration: '9 Weeks', level: 'Intermediate', mode: 'Online / Hybrid', placement: 'Yes', certification: 'CloudXAI Certified', tools: 'Selenium, AI Frameworks, Python' },
  { name: 'Microsoft Fabric Data Engineer', duration: '12 Weeks', level: 'Intermediate-Advanced', mode: 'Online / Hybrid', placement: 'Yes', certification: 'Microsoft + CloudXAI', tools: 'Microsoft Fabric, Lakehouse, Power BI' },
];

const CourseComparisonPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0F1A]">
      <Header />

      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0B0F1A] to-[#020617]">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 font-['Space_Grotesk']" data-testid="comparison-heading">
            Course <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Comparison</span>
          </h1>
          <p className="text-lg text-[#9CA3AF] max-w-2xl mx-auto">Compare all programs side-by-side to find the perfect fit for your career goals.</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto overflow-x-auto">
          <Card className="bg-[#111827] border-2 border-[#00E5FF]/20 overflow-hidden">
            <CardContent className="p-0">
              <table className="w-full min-w-[900px]" data-testid="comparison-table">
                <thead>
                  <tr className="bg-[#0B0F1A] border-b border-[#00E5FF]/20">
                    <th className="text-left px-6 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Program</th>
                    <th className="text-left px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Duration</th>
                    <th className="text-left px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Level</th>
                    <th className="text-left px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Mode</th>
                    <th className="text-center px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Placement</th>
                    <th className="text-left px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Certification</th>
                    <th className="text-left px-4 py-4 text-[#00E5FF] font-bold text-sm uppercase tracking-wider">Key Tools</th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((c, i) => (
                    <tr key={i} className="border-b border-[#00E5FF]/10 hover:bg-[#00E5FF]/5 transition-colors">
                      <td className="px-6 py-4 text-white font-semibold text-sm">{c.name}</td>
                      <td className="px-4 py-4 text-[#1DE9B6] font-medium text-sm">{c.duration}</td>
                      <td className="px-4 py-4 text-[#9CA3AF] text-sm">{c.level}</td>
                      <td className="px-4 py-4 text-[#9CA3AF] text-sm">{c.mode}</td>
                      <td className="px-4 py-4 text-center"><CheckCircle2 className="w-5 h-5 text-[#1DE9B6] mx-auto" /></td>
                      <td className="px-4 py-4 text-[#9CA3AF] text-sm">{c.certification}</td>
                      <td className="px-4 py-4 text-[#9CA3AF] text-sm">{c.tools}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </div>

        <div className="max-w-4xl mx-auto text-center mt-12">
          <p className="text-[#9CA3AF] mb-6">Not sure which program is right for you? Our counselors can help.</p>
          <Link to="/book-a-consultation">
            <Button className="bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-semibold px-8 py-5 text-base rounded-lg shadow-lg shadow-[#00E5FF]/40">
              Get Free Guidance
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default CourseComparisonPage;
